import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from 'types';
import { isFundingRisk } from '../../../../utilities/risks';

interface Props {
  id: string;
  showRisks: boolean;
  risks: IRisk['docsRisk']['parentalConsent'];
  isDated?: boolean;
  isSigned?: boolean;
  uploadedBy?: string;
}

function ParentalConsent({ id, showRisks, risks, isDated, isSigned, uploadedBy }: Props) {
  if (isDated === undefined && isSigned === undefined) {
    return <div>Uploaded by {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="letterDated"
        label="Letter Dated"
        fullLabel="Is your letter dated?"
        value={isDated === undefined ? 'N/A' : isDated ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risks, 'isDated', id)}
      />

      <SummaryRow
        key="parentsSignature"
        label="Parents Signatures"
        fullLabel="Is the letter signed by both parents/guardians (or one parent if they have sole responsibility)?"
        value={isSigned === undefined ? 'N/A' : isSigned ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risks, 'isSigned', id)}
      />
    </>
  );
}

export default ParentalConsent;
